<div class="container-fluid">
	<form [formGroup]="myForm" (ngSubmit)="onSubmit()">
		<div class="row paddingContainer">
			<ng-template mat-tab-label>
				{{ "cebe.generalData.headerData" | translate }}
			</ng-template>
			<div class="col">
				<div class="inputBlock">
					<mat-label>{{
						"cebe.generalData.codigo" | translate
					}}</mat-label>
					<input
						type="hidden"
						formControlName="id"
						[value]="myForm.get('id').value"
					/>
					<input
						matInput
						type="text"
						[value]="cebe?.codigo"
						class="dataInput"
						formControlName="codigo"
						readonly
					/>
				</div>
				<div class="inputBlock">
					<mat-label class="requerido">{{
						"cebe.generalData.description" | translate
					}}</mat-label>
					<input
						matInput
						type="text"
						[value]="cebe?.descripcion"
						class="dataInput"
						formControlName="descripcion"
						readonly
					/>
					<mat-error
						*ngIf="
							myForm.get('descripcion').hasError('required') &&
							myForm.get('descripcion').touched
						"
					>
						{{ "messages.requiredField" | translate }}
					</mat-error>
				</div>
				<div class="inputBlock">
					<mat-label>{{
						"cebe.generalData.sociedad" | translate
					}}</mat-label>

					<input
						matInput
						type="text"
						[value]="sociedad?.descripcion"
						class="dataInput"
						formControlName="sociedad"
						readonly
					/>
				</div>
				<div class="dataBlock">
					<div class="profile-container">
						<img
							[src]="photo"
							class="img-responsive profile-image"
							alt=""
						/>
						<div class="profile-content">
							<mat-form-field class="example-full-width">
								<mat-label>{{
									"cebe.generalData.projectManager"
										| translate
								}}</mat-label>
								<input
									type="text"
									[placeholder]="
										'shared.refineSearch' | translate
									"
									aria-label="Número"
									matInput
									class="dataInput"
									[formControl]="employeeControl"
									[matAutocomplete]="auto"
									#nombreInput
									[readonly]="!this.cebe?.edicionCebe"
								/>
								<cdk-virtual-scroll-viewport
									class="autocomplete-test-viewport"
									itemSize="50"
									minBufferPx="500"
									maxBufferPx="750"
								>
									<mat-autocomplete
										#auto="matAutocomplete"
										[displayWith]="displayFn"
										(optionSelected)="
											onOptionSelected($event)
										"
									>
										<mat-option
											*cdkVirtualFor="
												let option of employeesfilter
											"
											[value]="option"
											class="autocomplete-item"
										>
											{{ option.nombre }}
										</mat-option>
									</mat-autocomplete>
								</cdk-virtual-scroll-viewport>
							</mat-form-field>
						</div>
					</div>
				</div>
				<div class="inputBlock">
					<mat-label>{{
						"cebe.generalData.supervision" | translate
					}}</mat-label>
					<mat-select
						class="dataInput"
						formControlName="zonaID"
						[disabled]="!this.cebe?.edicionCebe"
					>
						<mat-option
							*ngFor="let item of zones"
							[value]="item.id"
						>
							{{ item.descripcion }}
						</mat-option>
					</mat-select>
				</div>
			</div>

			<div class="col">
				<div class="inputBlock">
					<mat-label
						>{{ "cebe.generalData.department" | translate }}
						<mat-icon
							class="info"
							[matTooltip]="
								this._translateService.instant(
									'cebe.generalData.descriptActivity'
								)
							"
							>info</mat-icon
						></mat-label
					>
					<mat-select
						class="dataInput"
						formControlName="actividadID"
						[disabled]="!this.cebe?.edicionCebe"
					>
						<mat-option
							*ngFor="let item of activities"
							[value]="item.id"
						>
							{{ "departments." + item.codigo | translate }}
						</mat-option>
					</mat-select>
				</div>
				<div class="inputBlock">
					<mat-label class="requerido"
						>{{ "cebe.generalData.projectType" | translate }}
						<mat-icon
							class="info"
							*ngIf="this.myForm.get('actividadID').value == 1"
							[matTooltip]="
								this._translateService.instant(
									'cebe.generalData.descriptTipoProyecto'
								)
							"
							>info</mat-icon
						>
					</mat-label>
					<mat-select
						class="dataInput"
						formControlName="tipoProyectoID"
						[disabled]="!this.cebe?.edicionCebe"
					>
						<mat-option
							*ngFor="let item of projectTypes"
							[value]="item.id"
						>
							{{ "site.type." + item.codigo | translate }}
						</mat-option>
					</mat-select>
					<mat-error
						*ngIf="
							myForm.get('tipoProyectoID').hasError('required') &&
							myForm.get('tipoProyectoID').touched
						"
					>
						{{ "messages.requiredField" | translate }}
					</mat-error>
				</div>
				<div class="inputBlock">
					<mat-label>{{
						"cebe.generalData.country" | translate
					}}</mat-label>
					<mat-select
						class="dataInput"
						formControlName="paisID"
						[disabled]="!this.cebe?.edicionCebe"
					>
						<mat-option [value]="null"> </mat-option>
						<mat-option
							*ngFor="let item of countries"
							[value]="item.id"
						>
							{{ "countries." + item.codigoIso2 | translate }}
						</mat-option>
					</mat-select>
					<mat-error
						*ngIf="
							myForm.get('paisID').hasError('required') &&
							myForm.get('paisID').touched
						"
					>
						{{ "messages.requiredField" | translate }}
					</mat-error>
				</div>
				<div class="inputBlockimagen">
					<mat-label>
						{{ "cebe.generalData.image" | translate }}
					</mat-label>

					<input
						type="file"
						accept="image/jpeg, image/png"
						(change)="onFileChange($event)"
						[disabled]="!cebe?.edicionCebe"
						class="dataInput custom-file-input"
					/>
				</div>
				<div *ngIf="!imagenPreview" class="mt-2">
					<small>{{
						"messages.imageRequiredType" | translate
					}}</small>
				</div>
				<div *ngIf="imagenPreview" class="mt-2">
					<img
						[src]="imagenPreview"
						alt="preview"
						style="
							max-width: 200px;
							border: 1px solid #ccc;
							padding: 4px;
						"
					/>
				</div>
			</div>
			<!-- </div> -->

			<!-- <div class="row paddingContainer align-items-center"> -->
			<!-- <div class="col">
        
      </div> -->
			<div class="col">
				<div class="inputBlock">
					<mat-label>{{
						"cebe.generalData.financialConsolidation" | translate
					}}</mat-label>
					<input
						matInput
						type="text"
						[value]="cebe?.uteConsolidacionFinanciera | translate"
						class="dataInput"
						formControlName="uteConsolidacionFinanciera"
						readonly
					/>
				</div>
				<div class="dataBlock">
					<mat-label class="paddingLabel">{{
						"cebe.generalData.participation" | translate
					}}</mat-label>
					<mat-label class="paddingLabel">{{
						this.myForm.get("porcentajeConsolidacion").value !==
							null &&
						this.myForm.get("porcentajeConsolidacion").value !==
							undefined
							? this.myForm.get("porcentajeConsolidacion").value +
								"%"
							: "0%"
					}}</mat-label>
					<mat-slider
						min="0"
						max="100"
						step="1"
						thumbLabel
						formControlName="porcentajeConsolidacion"
						[disabled]="true"
					>
					</mat-slider>
				</div>
				<div class="dataBlock">
					<mat-slide-toggle
						[checked]="cebe?.sostenibilidad ?? false"
						color="warn"
						formControlName="sostenibilidad"
						[disabled]="!this.cebe?.edicionCebe"
					>
					</mat-slide-toggle>
					<mat-label class="checkBoxPanel"
						>{{ "cebe.generalData.sustainability" | translate }}
					</mat-label>
					<mat-icon
						class="info"
						[matTooltip]="
							this._translateService.instant(
								'cebe.generalData.descripSustainability'
							)
						"
						>info</mat-icon
					>
				</div>
				<div class="dataBlock">
					<mat-slide-toggle
						[checked]="cebe?.isContrato ?? false"
						color="warn"
						formControlName="isContrato"
						[disabled]="!this.cebe?.edicionCebe"
						#contratoValue
						(change)="
							sendContratoToggleEvent(contratoValue.checked)
						"
					>
					</mat-slide-toggle>
					<mat-label class="checkBoxPanel">{{
						"cebe.generalData.contract" | translate
					}}</mat-label>
					<mat-icon
						class="info"
						[matTooltip]="
							this._translateService.instant(
								'cebe.generalData.descripContract'
							)
						"
						>info</mat-icon
					>
				</div>
				<div class="dataBlock">
					<mat-slide-toggle
						[checked]="cebe?.oferta ?? false"
						color="warn"
						formControlName="oferta"
						[disabled]="!this.cebe.edicionCebe"
						#ofertaValue
						(change)="sendOfertaToggleEvent(ofertaValue.checked)"
					>
					</mat-slide-toggle>
					<mat-label class="checkBoxPanel">{{
						"cebe.generalData.offer" | translate
					}}</mat-label>
					<mat-icon
						class="info"
						[matTooltip]="
							this._translateService.instant(
								'cebe.generalData.descripOffer'
							)
						"
						>info</mat-icon
					>
				</div>
				<div class="dataBlock">
					<mat-slide-toggle
						[checked]="cebe?.centro ?? false"
						color="warn"
						formControlName="centro"
						[disabled]="!this.cebe.edicionCebe"
						#centroValue
						(change)="sendCentroToggleEvent(centroValue.checked)"
					>
					</mat-slide-toggle>
					<mat-label class="checkBoxPanel">{{
						"cebe.generalData.prodCenter" | translate
					}}</mat-label>
					<mat-icon
						class="info"
						[matTooltip]="
							this._translateService.instant(
								'cebe.generalData.descripProductionCenter'
							)
						"
						>info</mat-icon
					>
				</div>
			</div>
		</div>
	</form>
	<div class="buttonBlock container">
		<div class="row justify-content-end">
			<div class="col-auto">
				<p
					style="display: inline"
					*ngIf="this.notificacionCese && this.notificacionAlta"
				>
					{{ getMensajeNotificacionCese() }}
				</p>
				<p
					style="display: inline"
					*ngIf="!this.notificacionCese && this.notificacionAlta"
				>
					{{ getMensajeNotificacionAlta() }}
				</p>
				<button
					*ngIf="this.notificacionAlta"
					class="marginButton"
					type="submit"
					mat-raised-button
					color="warn"
					(click)="confirm1($event, false)"
					[disabled]="
						this.cebe.edicionCebe
							? this.notificacionCese?.id > 0
								? true
								: false
							: false
					"
				>
					{{ "cebe.generalData.NotificarCese" | translate }}
				</button>
				<button
					*ngIf="!this.notificacionAlta"
					class="marginButton"
					type="submit"
					mat-raised-button
					color="warn"
					(click)="confirm1($event, true)"
					[disabled]="!this.cebe.edicionCebe"
				>
					{{ "cebe.generalData.NotificarAlta" | translate }}
				</button>
			</div>
		</div>
	</div>
</div>
<p-confirmDialog #cd>
	<ng-template pTemplate="headless" let-message>
		<div
			class="flex flex-column align-items-center p-5 surface-overlay border-round"
		>
			<div
				class="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem"
			>
				<i class="pi pi-question text-5xl"></i>
			</div>
			<span class="font-bold text-2xl block mb-2 mt-4">
				{{ message.header }}
			</span>
			<p class="mb-0">{{ message.message }}</p>
			<div class="flex align-items-center gap-2 mt-4">
				<button
					pButton
					label="Save"
					(click)="cd.accept()"
					class="w-8rem"
				></button>
				<button
					pButton
					label="Cancel"
					(click)="cd.reject()"
					class="p-button-outlined w-8rem"
				></button>
			</div>
		</div>
	</ng-template>
</p-confirmDialog>
